export default __webpack_public_path__ + "static/media/love.d90d8872.svg";